import React from 'react';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { NavBar } from '../components/NavBar';
import { HeroSection } from '../components/HeroSection';
import { EmpathySection } from '../components/EmpathySection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { MethodSection } from '../components/MethodSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useMetaPixel();
  return <div className="min-h-screen overflow-x-hidden" data-id="element-219">
      <NavBar data-id="element-220" />
      <HeroSection data-id="element-221" />
      <EmpathySection data-id="element-222" />
      <ProblemSection data-id="element-223" />
      <SolutionSection data-id="element-224" />
      <MethodSection data-id="element-225" />
      <TestimonialsSection data-id="element-226" />
      <CTASection data-id="element-227" />
      <GuaranteeSection data-id="element-228" />
      <FinalCTASection data-id="element-229" />
      <Footer data-id="element-230" />
    </div>;
}